/*
 * Project: LegalPlace assistant
 * File: src\logic\variable_wrapper.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import { detectType, OptionType, MULTIPLE_PARENTS, FSIZE, ISCONDITIONAL, HELPER, TYPE, LABEL } from './lp_map_utils';

// the variable wrapper
export class VariableWrapper {
    id = -1;
    label = "";
    helper = "";
    type = OptionType.NONE;
    phSize = 16;
    has_multipleParents = false; //nice joke XD (has multiple parents lol)
    is_conditional = false;
    constructor( obj ) {
        this.id = obj['id'];
        this.label = obj[LABEL];
        this.type = detectType( obj[TYPE] );
        this.phSize = obj[FSIZE];
        this.has_multipleParents = obj[MULTIPLE_PARENTS];
        this.is_conditional = obj[ISCONDITIONAL];
        this.helper = obj[HELPER];
    }

}


// WEBPACK FOOTER //
// ./src/logic/variable_wrapper.js